import React from "react";
import styled from "styled-components";
import { isEmpty } from "lodash";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { Table } from "@sonder/ui/source/styled/fragments/Table";
import { sizes } from "@sonder/ui/source/styled/theme";
import { useStore as useAuthStore } from "auth/store";
import { useGetQAEmailConfigurations } from "core/queries/GetQAEmailConfigurations";
import { QualityAuditsEmailConfigurationHeaderRow } from "quality_audits_email_configuration/components/QualityAuditsEmailConfigurationHeaderRow";
import { QualityAuditsEmailConfigurationRow } from "quality_audits_email_configuration/components/QualityAuditsEmailConfigurationRow";
// TODO: Use your own store... :P
import { useStore as useScheduleStore } from "schedule/store";
import { EmptyRow, TaskTitle } from "tasks/components/TaskList";

const StyledScroller = styled(Scroller)`
  border-radius: 0 0 0.3rem 0.3rem;
`;

const QualityAuditsListOuterContainer = styled.div`
  box-sizing: border-box;
  max-width: ${sizes.listWidth};
  margin: 0 auto;
  width: 100%;
  padding: 1rem 1rem 1rem 1.5rem;
`;

export const QualityAuditsEmailConfigurationList = () => {
  const { state: authState } = useAuthStore();
  const {
    state: {
      filters: { cleaningCompanyIds },
    },
  } = useScheduleStore();
  const { data, error, loading } = useGetQAEmailConfigurations({
    skip: !authState?.user?.cityId,
    variables: {
      filters: {
        cityIds: authState?.user?.cityId ? [authState?.user?.cityId] : [],
        companyIds: cleaningCompanyIds || [],
      },
      pagination: {
        cursor: "0",
        limit: 1000,
      },
    },
  });
  const qaEmailConfigurations =
    data?.qaEmailConfigurationConnections.qaEmailConfigurations || [];
  const qaEmailConfigurationsCount =
    data?.qaEmailConfigurationConnections.total || 0;
  return (
    <QualityAuditsListOuterContainer>
      <TaskTitle
        count={qaEmailConfigurationsCount}
        isCollapsed={false}
        title="Configurations"
      />
      <StyledScroller>
        <ScrollerContent>
          <Table columns="15rem minmax(15rem, 1fr) 3.5rem">
            <QualityAuditsEmailConfigurationHeaderRow />
            {isEmpty(qaEmailConfigurations) && (
              <EmptyRow
                errorLabel={error ? "Something went wrong" : undefined}
                label="No email configurations"
                loadingLabel={loading ? "Loading..." : undefined}
              />
            )}
            {qaEmailConfigurations.map(({ id, ...rest }) => (
              <QualityAuditsEmailConfigurationRow id={id} key={id} {...rest} />
            ))}
          </Table>
        </ScrollerContent>
      </StyledScroller>
    </QualityAuditsListOuterContainer>
  );
};
